import { Button, Box, Paper, Typography, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import { Link } from "react-router-dom";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { theme } from "./MaterialStyling";
import LinksTable from "./MaterialComponents/LinksTable";
import propTypes from "prop-types";

const PREFIX = "ThankYouPage";

const classes = {
  root: `${PREFIX}-root`,
  layout: `${PREFIX}-layout`,
  container: `${PREFIX}-container`,
  buttons: `${PREFIX}-buttons`,
  button: `${PREFIX}-button`,
};

const StyledStyledEngineProvider = styled(StyledEngineProvider)(
  ({ theme }) => ({
    [`& .${classes.root}`]: {
      position: "relative",
      display: "flex",
      justifyContent: "center",
      gap: "16px",
      flexDirection: "column",
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      padding: theme.spacing(2),
      [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
        marginBottom: theme.spacing(6),
        padding: theme.spacing(3),
      },
    },

    [`& .${classes.layout}`]: {
      width: "auto",
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),

      [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
        width: 630,
        marginLeft: "auto",
        marginRight: "auto",
      },
    },

    [`& .${classes.container}`]: {
      height: "100vh",
      width: "100vw -54px",
    },

    [`& .${classes.buttons}`]: {
      display: "flex",
      justifyContent: "space-between",
    },

    [`& .${classes.button}`]: {
      marginTop: theme.spacing(3),
      marginLeft: theme.spacing(1),
    },
  })
);

export default function ThankYouPage({ match, newStudySuccessMessage }) {
  return (
    <StyledStyledEngineProvider injectFirst>
      
      <ThemeProvider theme={theme}>
        <div className={classes.container}>
          <Box className={classes.layout}>
            <Paper elevation={2} className={classes.root}>
              <React.Fragment>
                <Typography
                  color="primary"
                  variant="h5"
                  gutterBottom
                >
                  Thank you for your order.
                </Typography>

                <Typography variant="subtitle1" component={"span"}>
                  Your project number is {match.params.id}. We will send you an
                  update when your order has been setup.
                </Typography>
                <div style={{ padding: 16 }}>
                  <LinksTable newURLs={newStudySuccessMessage} />
                </div>
                <Grid container spacing={2} justifyContent="flex-end">
                  <Button component={Link} to="/" className={classes.button}>
                    Back to home
                  </Button>
                  <Button
                    component={Link}
                    to={`/my_studies/overview/${match.params.id}/`}
                    className={classes.button}
                  >
                    Continue to study details
                  </Button>
                </Grid>
              </React.Fragment>
            </Paper>
          </Box>
        </div>
      </ThemeProvider>
      
    </StyledStyledEngineProvider>
  );
}

ThankYouPage.propTypes = {
  match: propTypes.object,
  newStudySuccessMessage: propTypes.object,
};